import {management} from '../../../index.js' //api
import {RainfallRepository} from '../../infra/knex/repositories/rainfall'

import {GetRainfallByIntervalUseCase} from './getRainfallByInterval'

export const getRainfallByIntervalUseCase=new GetRainfallByIntervalUseCase(new RainfallRepository(management))
